<template>
	<div class="background-white">
		<AppHeader
			:title="$store.state.language === 'en'
				? 'Live'
				: 'Live'"
			:show-back="true"
			:has-actions="true"
		/>
		<div>
			<div :style="itemsCart.length > 0 ? 'margin-bottom: 7rem !important' : ''">
				<div class="container d-flex justify-content-center mb-3">
					<div
						class="mr-2 pt-1"
						style="border-radius: 10px"
						v-if="liveMatches.length > 0 || pendingMatches.length > 0"
					>
						<div class="tabs">
							<button
								class="tab-button"
								:class="tab === 'Live' ? 'active' : ''"
								@click="openTab('Live')"
							>
								Live
							</button>
							<button
								class="tab-button"
								:class="tab === 'Pending' ? 'active' : ''"
								@click="openTab('Pending')"
							>
								Coming soon
							</button>
						</div>
						<!-- <b class="text-white px-3">Today Matches</b> -->
					</div>
					<div
						class="text-center align-items-center mt-5 pt-5"
						v-else
					>
						<Loading
							color="#0F8606"
							size="24"
							class="px-4 py-0 m-auto pb-2 pt-5"
						/>
						<span class="text-danger font-weight-bold">
							{{
								$store.state.language === "en"
									? "Please wait. "
									: "ဘောလုံးပွဲစဉ်များအား ရယူနေပါသည်။ "
							}}
							<br>
							{{
								$store.state.language === "en"
									? "Football matches are fetching! "
									: "ခေတ္တစောင့်ဆိုင်းပေးပါ။"
							}}
						</span>
					</div>

				</div>
				<div class="container">
					<div
						class="card work"
						v-for="(item, itemKey) in tab === 'Live'
							? liveMatches
							: pendingMatches"
						:key="itemKey"
						@click="item.is_live == 1 ? redirectRoute('video-Links', { index: item.id }) : ''"
					>
						<div class="d-flex flex-column p-3">
							<div class="d-flex mb-2 justify-content-center">
								<b style="text-align: center">{{ item.league_name }}</b>
							</div>
							<div class="d-flex justify-content-around">
								<div
									class="d-flex flex-column align-items-center"
									style="width: 130px"
								>
									<img :src="item.home_logo" />
									<h3
										class="pt-2"
										style="font-weight: bold"
									>
										{{ item.home_name }}
									</h3>
								</div>
								<div class="d-flex flex-column">
									<div class="mt-4 mb-1 mx-auto">
										<p
											class="text-white pt-1 my-auto"
											id="pTag"
										>Vs</p>
									</div>
									<div
										class="mx-auto mt-2"
										v-if="item.is_live == 1"
									>
										<p class="badge badge-danger pt-2 my-auto live">LIVE</p>
									</div>
									<div
										class="mx-auto mt-2"
										v-if="item.is_live == 0"
									>
										<p class="badge badge-success pt-2 my-auto">
											{{ currentTime(item.date_time) }}
										</p>
									</div>
								</div>
								<div
									class="d-flex flex-column align-items-center"
									style="width: 130px"
								>
									<img :src="item.away_logo" />
									<h3
										class="pt-2"
										style="font-weight: bold"
									>
										{{ item.away_name }}
									</h3>
								</div>
							</div>
						</div>
						<div class="layer">
							<i
								class="fa-solid fa-circle-play text-white"
								style="font-size: 50px !important"
							></i>
							<h5 class="pt-1 text-white">
								{{ $store.state.language === "en" ? "Play" : "Play" }}
							</h5>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import { Loading } from 'vant';
import { mapActions } from 'vuex';
export default {
	components: { Loading, AppHeader },
	name: "Live",
	data: () => ({
		itemsCart: [],
		tab: "Live",
		liveMatches: [],
		pendingMatches: [],
	}),
	methods: {
		...mapActions(['fetchUser']),
		currentTime(time) {
			return moment(time).format('lll');
		},
		openTab(tabName) {
			this.tab = tabName;
		},
		async translateText(text, targetLanguage) {
			try {
				const translate = require("google-translate-api");

				const { text: translatedText } = await translate(text, {
					to: targetLanguage,
				});
				// console.log(`Original: ${text}`);
				console.log(`Translation: ${translatedText}`);
			} catch (error) {
				console.error("Error translating text:", error);
			}
		},
		async redirectRoute(path, query) {
			try {
				// console.log("query", query);
				// if (path === 'tip') {
				//   const text = this.$store.state.language === 'en'
				//     ? 'This feature is not support yet.'
				//     : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
				//   Dialog.alert({
				//     message: text,
				//     confirmButtonText:
				//                     this.$store.state.language === 'en'
				//                       ? 'Okay'
				//                       : 'Okay',
				//   }).then(() => {
				//     // on close
				//   });
				// } else {
				this.$router.push({ path, query });
				// }
			} catch (error) {
				console.log(error);
			}
		},
		async fetchMatches() {

			const apiUrl = 'https://aktech.store/api/v1/aktech/live';

			// Define your API key
			const apiKey = 'uwejfkyakdsg5s5dghkhskjd';

			// Make a GET request using the fetch function with headers
			fetch(apiUrl, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'x-api-key': apiKey // Add the x-api-key header
				}
			}).then(response => {
				// Check if the request was successful (status code 2xx)
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				// Parse the JSON response
				return response.json();
			})
				.then(data => {
					this.liveMatches = data.filter(
						(match) => match.is_live == 1
					);

					this.pendingMatches = data.filter(
						(match) => match.is_live == 0
					);
				})
				.catch(error => {
					// Handle errors
					console.error('Error fetching data:', error);
				});
		},
	},
	watch: {
		tab() {
			if (this.tab === "Live") {
			}
		},
	},
	async mounted() {
		const authUser = await this.fetchUser();
		if (!authUser) {
			this.$router.push('/auth/login');
		}
		this.fetchMatches();
	},
};
</script>

<style scoped>
.card {
	cursor: pointer;
	width: 100%;
	/* height: 170px; */
	border-radius: 10px !important;
}

img {
	width: 70px;
	height: 70px;
}

#pTag {
	width: 60px;
	height: 30px;
	background: #0F8606;
	font-weight: bolder;
	border-radius: 20px;
	text-align: center;
}

.layer {
	opacity: 0.9;
	width: 100%;
	height: 0;
	background: linear-gradient(#d7d2c9, #222222);
	border-radius: 10px;
	position: absolute;
	left: 0;
	bottom: 0;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 0 40px;
	text-align: center;
	font-size: 14px;
	transition: height 0.5s;
}

.work:hover img {
	transform: scale(1.1);
}

.work:hover .layer {
	height: 100%;
}

.live {
	animation-name: live-number-animation;
	animation-duration: 2s;
	animation-iteration-count: infinite;
}

@keyframes live-number-animation {
	from {
		background-color: red;
		color: white;
	}

	to {
		background-color: #fdd1da;
		color: red;
	}
}

.coming {
	animation-name: coming-number-animation;
	animation-duration: 2s;
	animation-iteration-count: infinite;
}

@keyframes coming-number-animation {
	from {
		background-color: blue;
		color: white;
	}

	to {
		background-color: #aaedf9;
		color: #03acca;
	}
}

/* NEw */
.tabs {
	display: flex;
	background-color: #ffffff;
	border-radius: 10px;
	overflow: hidden;
	width: 300px;
	padding: 4px;
	gap: 4px;
}

.tab-button {
	flex-grow: 1;
	background-color: #64ec3b42;
	border: none;
	border-radius: 8px;
	outline: none;
	cursor: pointer;
	padding: 10px 12px;
	transition: background-color 0.3s ease;
	font-size: 17px;
}

.tab-button:hover,
.tab-button.active {
	background-color: #0F8606;
	color: white;
}
</style>
